import React from "react";
import { Helmet } from "react-helmet";
import Loader from "../../../components/common/Loader";
import Footer from "../../../components/home1/Footer";
import Menu from "../../../components/innerpage/Menu";
import Navbar from "../../../components/home1/Navbar";
import ServiceDetail from "../../../components/innerpage/service_detail/ServiceDetail";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "../../../seoConfig";

const PAGE_TITLE = "Interior Design Services | " + SITE_NAME;
const PAGE_DESC =
  "Bespoke residential and commercial interior design — space planning, modular kitchens, false ceilings, lighting, and turnkey interior solutions tailored to your lifestyle.";
const PAGE_PATH = "/innerpages/services/interior-design";

function InteriorDesign() {
  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESC} />
        <meta
          name="keywords"
          content="interior design, residential interiors, office interiors, modular kitchen design, false ceiling design, turnkey interior solutions, 3D interior visualization"
        />
        <link rel="canonical" href={`${SITE_URL}${PAGE_PATH}`} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESC} />
        <meta property="og:url" content={`${SITE_URL}${PAGE_PATH}`} />
        <meta property="og:image" content={`${SITE_URL}${DEFAULT_OG_IMAGE}`} />
        <meta property="og:site_name" content={SITE_NAME} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESC} />
        <meta name="twitter:image" content={`${SITE_URL}${DEFAULT_OG_IMAGE}`} />

        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/navbar-fix.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
        <body className="inner-pages-style1 s-project-pg-style1 service-detail-page" />
      </Helmet>
      <Loader />
      <Menu />
      <div className="smooth-scroll-content" id="scrollsmoother-container">
        <Navbar />
        <main>
          <ServiceDetail
            tag="Interior"
            title="Interior Design"
            intro="A thoughtfully designed interior has the power to transform the way people live, work, and interact with a space."
            heroImage="/innerpages/assets/img/services/2.png"
            // TODO: swap these 4 paths for your actual image files
            gallery={[
              "/innerpages/assets/img/services/gallery/interior-1.jpg",
              "/innerpages/assets/img/services/gallery/interior-2.jpg",
              "/innerpages/assets/img/services/gallery/interior-3.jpg",
              "/innerpages/assets/img/services/gallery/interior-4.jpg",
            ]}
            paragraphs={[
              "Our interior design philosophy is centered on creating environments that are beautiful, functional, and tailored to the people who use them. Every project is approached with a deep understanding of our client's lifestyle, preferences, and practical requirements.",
              "We combine intelligent space planning with carefully selected materials, textures, colors, lighting, and furnishings to create interiors that feel balanced, inviting, and timeless. Every detail is thoughtfully considered, from maximizing natural light and storage to selecting finishes that enhance both aesthetics and durability.",
              "Whether designing a luxury residence, corporate office, retail showroom, restaurant, or hospitality space, our focus remains on creating interiors that elevate everyday experiences while maintaining exceptional quality and craftsmanship.",
              "Our end-to-end design process ensures consistency from the initial concept through detailed drawings, 3D visualizations, material selection, execution guidance, and final styling, delivering spaces that exceed expectations.",
            ]}
            listTitle="Our Interior Design Services"
            listItems={[
              "Residential Interior Design",
              "Commercial & Office Interiors",
              "Space Planning & Layout Optimization",
              "Modular Kitchen Design",
              "Bedroom & Living Room Design",
              "False Ceiling & Lighting Design",
              "Custom Storage Solutions",
              "Material, Color & Finish Selection",
              "3D Interior Visualization",
              "Turnkey Interior Solutions",
            ]}
            otherServices={[
              {
                title: "Architecture & Exterior Design",
                link: "/innerpages/services/architecture-exterior-design",
              },
              {
                title: "Furniture Design",
                link: "/innerpages/services/furniture-design",
              },
              {
                title: "Project Consultation",
                link: "/innerpages/services/project-consultation",
              },
            ]}
          />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default InteriorDesign;
